import React from 'react';
import DefaultLayout from '../../../layout/DefautlLayout';
import Header from '../../../components/header/Header';
import { Link } from 'react-router-dom';
import TreatmentIntroBanner from '../../../components/treatmentBanner/treatmentBanner';

const ChemicalPeelsPage = () => {
	const prices = [{ label: 'Treatment', value: '€250/£170' }];
	return (
		<DefaultLayout>
			<Header />
			<div id="Content">
				<div className="content_wrapper clearfix">
					<div className="sections_group">
						<div className="extra_content">
							<TreatmentIntroBanner
								title="Chemical Peels"
								description="A controlled chemical exfoliation that improves tone, texture, and clarity—helping to reduce fine lines, acne scars, and pigmentation while revealing smoother, brighter, more radiant skin."
								quote="Refresh your skin's natural radiance."
								backgroundImage="/assets/images/banners/treatment-xl-2.png"
							/>

							<div className="section mcb-section" id="image" style={{ paddingBottom: '70px' }}>
								<div className="section_wrapper mcb-section-inner">
									<div className="wrap mcb-wrap one valign-top clearfix">
										<div className="mcb-wrap-inner">
											<div className="column mcb-column one-third column_image">
												<div className="image_frame image_item scale-with-grid aligncenter has_border hrmargin_b_30">
													<div className="image_wrapper">
														<div className="mask"></div>
														<img
															className="scale-with-grid"
															src="/assets/images/treatments/chemical-peel.jpg"
															alt="Chemical Peel Procedure"
															width="960"
															height="960"
														/>
													</div>
												</div>
											</div>

											<div className="column mcb-column two-third column_column">
												<div className="column_attr clearfix">
													<h4>How It Works</h4>
													<p>
														A tailored chemical solution is applied to the skin under medical supervision, causing the outer layer
														to shed and reveal smoother, fresher skin beneath. The depth is chosen depending on your concern.
													</p>

													<h4>What to Expect</h4>
													<ul>
														<li>A medical assessment determines the appropriate peel strength.</li>
														<li>The peel is applied gently in-office.</li>
														<li>Superficial peels lead to gentle peeling and brighter skin with minimal downtime.</li>
														<li>Medium peels may lead to mild crusting and redness; recovery spans several days.</li>
														<li>Deep peels may require escorted downtime and longer healing, with more dramatic renewal.</li>
													</ul>

													<h4>Benefits</h4>
													<ul>
														<li>Softens fine lines and superficial wrinkles</li>
														<li>Reduces acne marks, mild scarring, pigmentation and sun damage</li>
														<li>Revitalises dull, uneven skin surface</li>
													</ul>

													<h4>Possible Side Effects</h4>
													<ul>
														<li>Temporary redness, flaking or peeling like a mild sunburn</li>
														<li>Skin lightening or darkening in sensitive skin tones</li>
														<li>In rare cases, blistering or prolonged irritation</li>
													</ul>
												</div>
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<div className="column one column_pricing_item">
														<div className="pricing-box custom-pricing-box pricing-box-table pricing-box-featured">
															<div className="plan-header">
																<h3>Pricing</h3>
															</div>
															<div className="plan-inside clearfix">
																<hr className="bg-theme" />
																<ul>
																	{prices.map(({ label, value }, idx) => (
																		<li key={idx} className="clearfix" style={{ paddingLeft: '5%', paddingRight: '5%' }}>
																			<div>
																				<strong>{label}</strong>
																			</div>
																			<div>{value}</div>
																		</li>
																	))}
																</ul>
																<hr className="bg-theme" />
															</div>
															<div className="plan-footer">
																<Link to="/book-now" className="button button_left button_theme button_js">
																	<span className="button_icon">
																		<i className="icon-basket"></i>
																	</span>
																	<span className="button_label">BOOK NOW</span>
																</Link>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>

											<div className="column one column_slider">
												<div className="column_attr clearfix hrmargin_b_60">
													<h2 className="hrmargin_b_60" style={{ textAlign: 'center' }}>
														Results
													</h2>
													<div className="content_slider">
														<ul className="content_slider_ul">
															<li className="content_slider_li_1">
																<img
																	width="100%"
																	height="auto"
																	src="/assets/images/treatments/chemical-peel-result.jpg"
																	alt="Chemical Peel Results"
																	className="scale-with-grid wp-post-image"
																/>
															</li>
														</ul>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<h2 className="hrmargin_b_60" style={{ textAlign: 'center' }}>
														After-Care
													</h2>
													<ul>
														<li>
															Use gentle cleansers, moisturisers, and broad-spectrum SPF daily to support healing and protect your
															skin barrier.
														</li>
														<li>
															Expect mild peeling or dryness—do not pick or force exfoliation to avoid scarring or irritation.
														</li>
														<li>
															Avoid direct sun, tanning, retinoids, or exfoliating acids until skin has fully healed and feels
															calm.
														</li>
														<li>
															Report prolonged redness, unusual blistering, or dark patches promptly to your clinician for
															evaluation and care.
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</DefaultLayout>
	);
};

export default ChemicalPeelsPage;
